import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import RoleSwitcher from "./ui/RoleSwitcher";
import { useSelector } from "react-redux";

const RoleSelectorModal = () => {
    const [show, setShow] = useState(false);
    const userGroups = useSelector(state => state.authentication.userGroups);
    const selectedRole = useSelector(state => state.authentication.selectedRole);

    useEffect(() => {
        if (!selectedRole && !localStorage.getItem("selectedRole") && userGroups.length > 1) {
            setShow(true);
        }
    }, [userGroups, selectedRole]);

    const handleClose = () => setShow(false);

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>Rolle auswählen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Bitte wählen Sie eine Rolle:</p>
                <RoleSwitcher userGroups={userGroups} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Schließen
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RoleSelectorModal;
